import { Component, OnInit, Input } from '@angular/core';
import dxChart from 'devextreme/viz/chart';
import { LanguageService } from '../../../../../shared/services/language.service';

let self: CustomReport2ElementComponent = null;
@Component({
  selector: 'app-custom-report2-element',
  templateUrl: './custom-report2-element.component.html',
  styleUrls: ['./custom-report2-element.component.css']
})
export class CustomReport2ElementComponent implements OnInit {

  private rre = null;
  @Input() set reportReportElement(val) {
    this.rre = val;
    if (val != null) {
      this.highThreshold = val.MaximumThresholdInDays;
      this.lowThreshold = val.MinimumThresholdInDays;
      if (!this.reportReportElement.MissingConfiguration) {
        this.thePeriod = `${val.StartDateFormattedShort} -> ${val.EndDateFormattedShort}`;
      }
    }
    else {
      this.highThreshold = null;
      this.lowThreshold = null;
      this.thePeriod = "";
    }
  }

  get reportReportElement() {
    return this.rre;
  }


  @Input() data: any;

  theChart: dxChart = null;
  visualRange = null;
  static HighThresholdColor = "red";
  static MiddleThresholdColor = "#ff9b52";
  static LowThresholdColor = "#6199e6";
  get highThresholdColor() {
    return CustomReport2ElementComponent.HighThresholdColor;
  }
  get middleThresholdColor() {
    return CustomReport2ElementComponent.MiddleThresholdColor;
  }
  get lowThresholdColor() {
    return CustomReport2ElementComponent.LowThresholdColor;
  }
  highThreshold: number;
  lowThreshold: number;
  thePeriod = "";
  isRedrawn = false;


  inspect(data) {
    
  }


  constructor(public ls: LanguageService) {
    self = this;
    this.data = null;
    this.reportReportElement = null;
    this.highThreshold = null;
    this.lowThreshold = null
    this.isRedrawn = false;
  }

  ngOnInit() {
    if (this.reportReportElement === null)
      return;
    
    let vr = { startValue: 0, endValue: null };
    if (this.reportReportElement.MinimumValueInDays > 0) {
      vr.startValue = this.reportReportElement.MinimumValueInDays;
    }
    if (this.reportReportElement.MaximumValueInDays > 0) {
      vr.endValue = this.reportReportElement.MaximumValueInDays;
    }

    if (vr.endValue == null && vr.startValue != null) {
      let minV = null, maxV = null;
      if (typeof (this.data) !== "undefined" && this.data !== null && this.data.length > 0) {
        //Fix the max value to be identical on the value axis (y-axis)
        minV = maxV = this.data[0].LagInDays_MinMaxLimited;
        for (let i = 1; i < this.data.length; i++) {
          const v = this.data[i].LagInDays_MinMaxLimited;
          if (v > maxV) {
            maxV = v;
          }
          else if (v < minV) {
            minV = v;
          }
        }
      }
      //not an ideal fallback
      if (this.reportReportElement.MaximumThresholdInDays > maxV) {
        vr.endValue = (this.reportReportElement.MaximumThresholdInDays + Math.max(1, this.reportReportElement.MinimumThresholdInDays));
      }
      else {
        vr.endValue = (maxV + Math.max(1, this.reportReportElement.MinimumThresholdInDays));
      }
    }

    if (vr.endValue != null && vr.startValue != null) {
      this.visualRange = vr;
    }
  }

  theChartOnInitialized(e) {
    this.theChart = e.component;
  }

  theChartOnDrawn(e) {
    if (!this.isRedrawn) {
      this.isRedrawn = true;
      const theThis = this;
      setTimeout(() => {
        theThis.theChart.render();
      }, 200);
    } 
  }

  refresh() {
    this.theChart.render();
  }

  customizePoint = (arg: any) => {
    const color = this.getPointColor(arg.value);
    return { color: color };
  }

  getPointColor(value) {
    let color = "green";
    if (value > this.highThreshold) {
      color = this.highThresholdColor;
    } else if (value > this.lowThreshold) {
      color = this.middleThresholdColor;
    }
    return color;
  }

  customizeLabel = (arg: any) => {
    let visible = false;
    let backgroundColor = "green";
    
    const theLag = arg.data.LagInDays;
    if (arg.value > this.highThreshold) {
      visible = true;
      backgroundColor = this.highThresholdColor
    } else if (arg.value > this.lowThreshold) {
      visible = true;
      backgroundColor = this.middleThresholdColor
    }
    return {
      visible: visible,
      backgroundColor: backgroundColor,
      customizeText: function (ee)
      {
        return theLag != null ? theLag.toFixed(1) : "";
      }
    };
  }

  _customizeLabel = (arg: any) => {
    if (arg.value > this.highThreshold) {
      return this.getLabelsSettings(this.highThresholdColor);
    } else if (arg.value > this.lowThreshold) {
      return this.getLabelsSettings(this.middleThresholdColor);
    }
  }

  getLabelsSettings = (backgroundColor: any) => {
    return {
      visible: true,
      backgroundColor: backgroundColor,
      customizeText: this.customizeTextValue
    };
  }

  customizeTextValue = (arg: any) => {
    return arg?.value?.toFixed(1);
  }

  customizeTextArgument = (arg: any) => {
    if (arg == null)
      return;

    let s = null;
    if (typeof (arg.value) !== 'undefined') {
      s = arg.value?.split("_");
    }
    else {
      s = arg.split("_");
    }
    return s !== null ? s[s.length - 1] : "";
  }

}
